import {} from "../half-edge/index.js";
import {} from "../node/index.js";
import {} from "./Net.js";
import { disconnectHalfEdge } from "./disconnectHalfEdge.js";
import { findInputPorts } from "./findInputPorts.js";
import { findOutputPorts } from "./findOutputPorts.js";
import { findPortEntryOrFail } from "./findPortEntryOrFail.js";
export function disconnectNode(net, node) {
    const ports = [...findInputPorts(net, node), ...findOutputPorts(net, node)];
    return ports.map((port) => {
        const portEntry = findPortEntryOrFail(net, port);
        if (portEntry.connection === undefined) {
            return undefined;
        }
        const halfEdge = portEntry.connection.halfEdge;
        disconnectHalfEdge(net, halfEdge);
        return halfEdge;
    });
}
//# sourceMappingURL=disconnectNode.js.map